export const DiagnosticsTypes = {
  Issue: 'Issue',
  Recommendation: 'Recommendation',
};
